import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../../styles/Website/CompanyStats.css';

function CompanyStats({ onOpenModal }) {
  const navigate = useNavigate();
  const [tradingVolume, setTradingVolume] = useState(2050000000000); // $2.05 Trillion
  const [activeClients, setActiveClients] = useState(200000);
  const [rating, setRating] = useState(4.8);
  const [tradesPerDay, setTradesPerDay] = useState(3600000);
  const [algoTrades, setAlgoTrades] = useState(60);

  const handleStartTrading = () => {
    navigate('/register');
  };

  const handleTryDemo = () => {
    navigate('/register');
  };

  // Update trading volume every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setTradingVolume(prev => {
        const increase = Math.random() * 50000000 + 10000000; // $10M to $60M increase
        return prev + increase;
      });
    }, 3000);
    const handleStartTrading = () => {
    navigate('/register');
  };

  const handleTryDemo = () => {
    navigate('/register');
  };

  return () => clearInterval(interval);
  }, []);

  // Update active clients every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveClients(prev => {
        const increase = Math.floor(Math.random() * 5) + 1; // 1-5 new clients
        return prev + increase;
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  // Update rating slightly every 10 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setRating(prev => {
        const change = (Math.random() - 0.5) * 0.02; // Small change
        const newRating = Math.max(4.7, Math.min(5.0, prev + change));
        return newRating;
      });
    }, 10000);
    return () => clearInterval(interval);
  }, []);

  // Update trades per day every 2 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setTradesPerDay(prev => {
        const increase = Math.floor(Math.random() * 100) + 50; // 50-150 trades
        return prev + increase;
      });
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Update algo trades percentage every 8 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setAlgoTrades(prev => {
        const change = (Math.random() - 0.5) * 2; // -1% to +1%
        const newPercent = Math.max(58, Math.min(65, prev + change));
        return newPercent;
      });
    }, 8000);
    return () => clearInterval(interval);
  }, []);

  const formatTradingVolume = (value) => {
    const trillion = value / 1000000000000;
    return `US$${trillion.toFixed(2)} Trillion`;
  };

  const formatNumber = (num) => {
    return num.toLocaleString('en-US');
  };

  const stats = [
    {
      value: formatTradingVolume(tradingVolume),
      label: 'TRADING VOLUME - OCTOBER 2025',
      color: '#00ff00',
      isLive: true
    },
    {
      value: `${formatNumber(activeClients)}+`,
      label: 'ACTIVE CLIENTS WORLDWIDE',
      color: '#00ff00',
      isLive: true
    },
    {
      value: `Excellent ${rating.toFixed(1)}/5`,
      label: 'RATING ON TRUSTPILOT',
      color: '#00ff00',
      isLive: true
    }
  ];

  const tradingStats = [
    {
      value: formatNumber(tradesPerDay),
      label: 'TRADES PER DAY',
      highlight: true,
      isLive: true
    },
    {
      value: 'Equinix NY4',
      label: 'TRADING HUB AT NEW YORK',
      highlight: false,
      isLive: false
    },
    {
      value: `${algoTrades.toFixed(1)}%`,
      label: 'ALGO TRADES (% OF ALL TRADES)',
      highlight: false,
      isLive: true
    }
  ];

  return (
    <>
      {/* Company Stats Hero */}
      <section className="company-stats-hero">
        <div className="container-wide">
          <div className="stats-hero-content">
            <div className="stats-left">
              <div className="stats-display">
                {stats.map((stat, index) => (
                  <div className={`stat-block ${stat.isLive ? 'live-updating' : ''}`} key={index}>
                    <div className="stat-value-large">
                      {stat.value}
                      {stat.isLive && <span className="live-badge">LIVE</span>}
                    </div>
                    <div className="stat-label-small">{stat.label}</div>
                  </div>
                ))}
              </div>
            </div>
            
            <div className="stats-right">
              <h2 className="stats-title">
                Give your automated trading system the edge
              </h2>
              <p className="stats-description">
              HijaAsset is one of the top choices for automated traders. 
                Our order matching engine located in the New York Equinix NY4 data centre 
                processes over {formatNumber(tradesPerDay)} trades per day with over two thirds of all trades 
                coming from automated trading systems.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Trading Stats Dark */}
      <section className="trading-stats-dark">
        <div className="container-wide">
          <div className="stats-grid-dark">
            <div className="stat-item-dark info-card">
              <h2>Our strength is in the numbers</h2>
              <p>HijaAsset is one of the largest Forex CFD providers in the world by trading volume.</p>
              <div className="cta-buttons">
                <button className="btn-start-trading" onClick={onOpenModal}>
                  Start Trading
                </button>
                <button className="btn-try-demo">Try a Free Demo</button>
              </div>
            </div>
            
            <div className={`stat-item-dark highlight ${tradingStats[0].isLive ? 'live-updating' : ''}`}>
              <div className="stat-icon-wrapper">
                <div className="stat-icon"></div>
              </div>
              <div className="stat-number">
                {tradingStats[0].value}
                {tradingStats[0].isLive && <span className="live-indicator-small">●</span>}
              </div>
              <div className="stat-description">{tradingStats[0].label}</div>
              <div className="stat-progress">
                <div className="progress-bar" style={{width: '85%'}}></div>
              </div>
              <div className="stat-footer-info" style={{color: 'white'}}>Real-time trading activity</div>
            </div>
            
            <div className={`stat-item-dark highlight ${tradingStats[1].isLive ? 'live-updating' : ''}`}>
              <div className="stat-icon-wrapper">
                <div className="stat-icon"></div>
              </div>
              <div className="stat-number">
                {tradingStats[1].value}
                {tradingStats[1].isLive && <span className="live-indicator-small">●</span>}
              </div>
              <div className="stat-description">{tradingStats[1].label}</div>
              <div className="location-details">
                <div className="detail-row">
                  <span className="detail-label" >Location:</span>
                  <span className="detail-value" style={{color: 'white'}}>New York, USA</span>
                </div>
                <div className="detail-row">
                  <span className="detail-label">Latency:</span>
                  <span className="detail-value" style={{color: 'white'}}>0.12ms</span>
                </div>
              </div>
            </div>
            
            <div className={`stat-item-dark highlight ${tradingStats[2].isLive ? 'live-updating' : ''}`}>
              <div className="stat-icon-wrapper">
                <div className="stat-icon"></div>
              </div>
              <div className="stat-number">
                {tradingStats[2].value}
                {tradingStats[2].isLive && <span className="live-indicator-small">●</span>}
              </div>
              <div className="stat-description">{tradingStats[2].label}</div>
              <div className="stat-chart">
                <div className="chart-bar algo-bar" style={{height: `${algoTrades}%`}}>
                  <span className="bar-label" style={{color: 'white'}}>Algo</span>
                </div>
                <div className="chart-bar manual-bar" style={{height: `${100 - algoTrades}%`}}>
                  <span className="bar-label" style={{color: 'white'}}>Manual</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Account Opening CTA */}
      <section className="account-cta-section">
        <div className="container-wide">
          <div className="cta-content">
            <h2 className="cta-title">Instant account opening & funding</h2>
            <p className="cta-subtitle">Trade within minutes!</p>
            <div className="cta-buttons-centered">
              <button className="btn-get-started" onClick={handleStartTrading}>
                Get Started
              </button>
              <button className="btn-free-demo" onClick={handleTryDemo}>Try a Free Demo</button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default CompanyStats;